module.exports = __webpack_public_path__ + "static/img/wajahilustrat.f441a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wajahilustrat.png
// module id = 0J9W
// module chunks = 36